import { apiClient, apiRequest, withToken } from './http-client';

export const uploadFileAsset = async (token, {
    file,
    purpose = '',
    tags = [],
    metadata = {},
    referenceType = '',
    referenceId = '',
    referenceField = '',
    referenceLabel = '',
    isPublic = true,
} = {}) => {
    const formData = new FormData();

    if (file) {
        formData.append('file', file);
    }

    if (purpose) {
        formData.append('purpose', purpose);
    }

    if (Array.isArray(tags) && tags.length > 0) {
        formData.append('tags', JSON.stringify(tags));
    }

    if (metadata && typeof metadata === 'object' && Object.keys(metadata).length > 0) {
        formData.append('metadata', JSON.stringify(metadata));
    }

    if (referenceType) {
        formData.append('referenceType', referenceType);
    }

    if (referenceId) {
        formData.append('referenceId', referenceId);
    }

    if (referenceField) {
        formData.append('referenceField', referenceField);
    }

    if (referenceLabel) {
        formData.append('referenceLabel', referenceLabel);
    }

    formData.append('isPublic', String(Boolean(isPublic)));

    return apiRequest({
        method: 'post',
        url: '/file/upload',
        headers: withToken(token),
        data: formData,
    }, 'No se pudo validar la sesión');
};

export const detachFileReference = async (token, fileId, data) => {
    return apiRequest({
        method: 'post',
        url: `/file/${fileId}/detach`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteFileAsset = async (token, fileId) => {
    return apiRequest({
        method: 'delete',
        url: `/file/${fileId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const getFileAssetBlob = async (token, fileId) => {
    try {
        const response = await apiClient({
            method: 'get',
            url: `/file/${fileId}/content`,
            headers: withToken(token),
            responseType: 'blob',
        });

        return {
            success: true,
            data: response?.data,
        };
    } catch (error) {
        return {
            success: false,
            message: error?.message || 'No se pudo obtener el archivo',
        };
    }
};

export const getFileStats = async (token) => {
    return apiRequest({
        method: 'get',
        url: '/file/stats',
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const getFileAssets = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/file/',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};
